//angular imports
import { Signal } from "@angular/core";

//local imports
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractCategoryNavModel, SelectCategoryMessage } from "@app/catalog-common";
import { CategoryModel } from "@app/catalog";

export class CategoriesNavModel   
  extends AbstractCategoryNavModel<CategoryModel> {

  constructor(
    messenger: Messenger,
    items: Signal<CategoryModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<CategoryModel>;
    this.messenger.send(new SelectCategoryMessage(navItem.value));
  }
}